import { gql } from '@apollo/client';

const SUPPORT_MODULES_QUERY = gql`
  query supportModules($filter: SupportModulesFilter, $limit: Int) {
    supportModules(filter: $filter, limit: $limit) {
      isSuccess
      message
      supportModules {
        id
        title
        description
        pdfUrl
      }
    }
  }
`;

export default SUPPORT_MODULES_QUERY;
